import React, { Component } from 'react'
import { TextArea, Segment, Image, Header, Icon } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import _, { max } from 'lodash'

import { URL_PATTERN } from '../constants/pattern'

const propTypes = {
  as: PropTypes.elementType,
  rows: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

const defaultProps = {
  as: TextArea,
  value: '',
  onChange: () => {},
}

class TextareaLinkPreview extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: _.defaultTo(props.value, defaultProps.value),
      isShowLinkPreviews: false,
      linkPreviews: [],
    }

    this.textareaLinkPreviewsRef = React.createRef()

    this.handleTextareaLinkPreviewOutsideClick = this.handleTextareaLinkPreviewOutsideClick.bind(this)
    this.debouncedLoadLinkPreviews = _.debounce(this.loadLinkPreviews, 500)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleTextareaLinkPreviewOutsideClick)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value: currentValue } = this.state
    const { value: nextValue } = nextProps

    if (!_.isEqual(currentValue, nextValue)) {
      this.setState(
        {
          value: nextValue,
        },
        () => this.loadLinkPreviews(),
      )
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleTextareaLinkPreviewOutsideClick)
    this.debouncedLoadLinkPreviews.cancel()
  }

  handleTextareaLinkPreviewOutsideClick(event) {
    if (_.isEmpty(this.textareaLinkPreviewsRef)) {
      return
    }

    const { isShowLinkPreviews } = this.state
    const isClickTextareaLinkPreviewElement = this.textareaLinkPreviewsRef.current.contains(event.target)

    if (isClickTextareaLinkPreviewElement && !isShowLinkPreviews) {
      this.setState({ isShowLinkPreviews: true })
    }

    if (!isClickTextareaLinkPreviewElement && isShowLinkPreviews) {
      this.setState({ isShowLinkPreviews: false })
    }
  }

  handleChange = (e, { value }) => {
    this.setState({ value }, () => {
      this.debouncedLoadLinkPreviews()

      if (this.props.onChange) {
        this.props.onChange(e, { value })
      }
    })
  }

  handleCopy = text => {
    navigator.clipboard.writeText(text).then(() => {
      // TODO: Show a success message or notification
    })
  }

  loadLinkPreviews = () => {
    const { value } = this.state

    const linkPreviews = _.uniq(value.match(URL_PATTERN))

    this.setState({
      linkPreviews,
    })
  }

  renderLinkPreviews() {
    const { isShowLinkPreviews, linkPreviews } = this.state
    return isShowLinkPreviews && !_.isEmpty(linkPreviews) ? (
      <Segment
        size="mini"
        className="TextareaLinkPreview__LinkPreviews"
        style={{
          position: 'absolute',
          zIndex: 2,
          width: '100%',
          overflow: 'auto',
          maxHeight: '8rem',
          marginTop: '0',
          padding: '0',
        }}
      >
        {_.map(linkPreviews, (link, index) => (
          <div
            key={index}
            className="TextareaLinkPreview__LinkPreviews__Item"
            style={{
              padding: '0.5rem 1.25rem 0.5rem 0.5rem',
              borderTop: `${_.min([index, 1])}px solid rgba(34,36,38,.15)`,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <Icon name="share square outline" style={{ fontSize: '1.25em' }} />

            <Header
              as="a"
              href={link}
              target="_blank"
              rel="noreferrer"
              title={link}
              content={link}
              color="blue"
              size="mini"
            />

            <Icon
              link
              title="Copy link"
              name="copy outline"
              style={{ position: 'absolute', right: '0', fontSize: '1.25em' }}
              onClick={() => this.handleCopy(link)}
            />
          </div>
        ))}
      </Segment>
    ) : null
  }

  render() {
    const { value } = this.state

    return (
      <div ref={this.textareaLinkPreviewsRef} className="TextareaLinkPreview">
        <div className="TextareaLinkPreview__TextArea">
          <TextArea {...this.props} value={value} onChange={this.handleChange} />
        </div>

        {this.renderLinkPreviews()}
      </div>
    )
  }
}

TextareaLinkPreview.propTypes = propTypes
TextareaLinkPreview.defaultProps = defaultProps

export default TextareaLinkPreview
